import { ShopifyConsent } from './shopify-consent';
import { AppTitle } from '@/components/app-header/app-header';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage
} from '@/components/ui/breadcrumb';
import { Link } from 'react-router-dom';

export const ShopifyTrackingDetails = () => {
  return (
    <div>
      <AppTitle>
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink className="text-base" asChild>
                <Link to="../../tracking">Tracking</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-base">Shopify</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </AppTitle>
      <ShopifyConsent />
    </div>
  );
};

export default ShopifyTrackingDetails;
